import EggPaintingGame from "./components/EggPaintingGame";

export default EggPaintingGame;
